import * as React from 'react';
export const SLSvg = React.forwardRef(function SLSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#24B47E',
        d: 'M1.994 2h12.012C15.106 2 16 2.895 16 4v2H0V4c0-1.112.893-2 1.994-2Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#F6F9FC',
        fillRule: 'nonzero',
        d: 'M0 6h16v4H0z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#EAEEF3',
        fillRule: 'nonzero',
        d: 'M15 10V6h1v4h-1ZM0 6h1v4H0V6Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#217AB7',
        d: 'M0 10h16v2c0 1.112-.893 2-1.994 2H1.994C.894 14 0 13.105 0 12v-2Z',
      }),
    ),
  );
});
SLSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
};
export var SL = {
  category: 'flag',
  colorable: false,
  name: 'SL',
  svg: SLSvg,
};
